exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-application a{cursor:pointer;text-decoration:none}.title-action{margin-left:3rem}.actions{z-index:2000;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;position:absolute;right:0}.about-title,.actions{display:-webkit-box;display:-ms-flexbox;display:flex}.about-title{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8df1078c","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/pages/overview/about.vue
// module id = nvRp
// module chunks = 1